export const ASK_AN_EXPERT_REGION = 'Epyc_Ask_an_Expert_region';
export const SELECT_REGION = 'Epyc_Select_region';
export const ASK_AN_EXPERT_LANGING_TOP = 'Epyc_Ask_an_Expert_landing_top';
export const REQUEST_PRICE_FOUNDATIONAL = 'Epyc_Request_price_quote_solution1';
export const REQUEST_PRICE_EXPAND = 'Epyc_Request_price_quote_solution2';
export const REQUEST_PRICE_ENTERPRISE = 'Epyc_Request_price_quote_solution3';
export const ASK_AN_EXPERT_LANGING_MIDDLE = 'Epyc_Ask_an_Expert_landing_configurator';
export const REQUEST_PRICE_QOUTE = 'Epyc_Request_price_quote_configurator';
export const ASK_AN_EXPERT_LANGING_BOTTOM = 'Epyc_Ask_an_Expert_landing_button';
export const SEND_BUTTON = 'Epyc_Send';
